import Navigation from "../../components/portugal/Navigation";
import TripHero from "../../components/portugal/TripHero";
import Travelers from "../../components/portugal/Travelers";
import StayDetails from "../../components/portugal/StayDetails";
import TravelInfo from "../../components/portugal/TravelInfo";
import Itinerary from "../../components/portugal/Itinerary";
import TripCosts from "../../components/portugal/TripCosts";
import Footer from "../../components/portugal/Footer";

const Index = () => {
  return (
    <main className="overflow-x-hidden">
      <Navigation />
      <TripHero />
      <Travelers />
      <section id="travel">
        <TravelInfo />
      </section>
      <section id="accommodations">
        <StayDetails />
      </section>Z
      <section id="itinerary">
        <Itinerary />
      </section>
      {/* <section id="costs">
        <TripCosts />
      </section> */}
      <Footer />
    </main>
  );
};

export default Index;